import React from 'react';

function NewWhy() {
  const features = [
    { icon: "🎉", text: 'Your Celebration, Our Private Theater!' },
    { icon: "🎈", text: 'Balloon Magic, Mood Fantastic!' },
    { icon: "🎂", text: 'Where Birthdays Become Blockbusters!' },
    { icon: "📸", text: 'Pose, Click, Print – Picture Perfect Moments!' },
    { icon: "🎮", text: 'Game. Sing. Laugh. Repeat!' },
    { icon: "🥗", text: 'Pure Veg, Pure Celebration – Curated Food Packages' },
    { icon: "💫", text: 'Little Guests, Big Joy – Kid-Friendly Pricing!' },
    { icon: "🤗", text: 'No Hidden Charges. Just Happy Surprises!' },
    { icon: "💸", text: 'GST Invoices & Hassle-Free Billing – Celebrate Smart' },
  ];

  return (
    <div className='updatedwhy'>
      <div className='updatedwhy-heading'>
        <h4>Why Us</h4>
        <h2>Why Choose Cine Celebrate for Private theater Celebration?</h2>
      </div>
      <br />
      <div className='updatedwhy-cards'>
        <div className='updatedwhy-track'>
          {[...features, ...features].map((feature, index) => (
            <div key={`${feature.text}-${index}`} className='updatedwhy-card-shell'>
              <div
                className={`updatedwhy-card ${
                  index % 3 === 0
                    ? "updatedwhy-card1"
                    : index % 3 === 1
                      ? "updatedwhy-card2"
                      : "updatedwhy-card3"
                }`}
              >
                <div className='icon' style={{ fontSize: "3rem" }}>{feature.icon}</div>
                <h3>{feature.text}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NewWhy;
